/* @ngInject */
const labels = () => {
  const self = {}

  self.titles = {
    accounts: 'Tous les comptes',
    connexion: 'Connection',
  }

  self.fields = {
    id: {
      text: 'Id de l\'utilisateur',
    },
    username: {
      text: 'Nom d\'utilisateur',
      messages: {
        exists: 'Ce nom d\'utilisateur existe déjà',
      },
    },
    password: {
      text: 'Mot de passe',
    },
    passwordConfirmation: {
      text: 'Confirmation du mot de passe',
    },
    newPassword: {
      text: 'Nouveau mot de passe',
    },
    currentPassword: {
      text: 'Mot de passe actuel',
    },
    admin: {
      text: 'Administrateur',
    },
    creationDate: {
      text: 'Date de création',
    },
  }

  self.ask = {
    logout: 'Êtes vous sûr de vouloir vous déconnecter ?',
    removeUser: 'Êtes-vous sûr de vouloir supprimer ce compte ?\nLes données liées à ce compte seront supprimées à jamais.',
  }

  self.connect = 'Se connecter'
  self.changePassword = 'Changer de mot de passe'
  self.createUser = 'Créer un nouvel utilisateur'
  self.consult = 'Consulter tous les comptes'

  self.accountOf = (_username) => {
    return 'Compte de ' + _username
  }

  self.registerUser = (_username) => {
    return 'L\'utilisateur ' + _username + ' a été enregistré dans la base.'
  }

  self.welcome = (_username) => {
    return 'Bienvenue ' + _username
  }

  return self
}

export default labels



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/resources/labels.resource.js